import SidebarLayout from '../components/SidebarLayout';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import OpenReferralsTable from '../components/sections/Dashboard/OpenReferralsTable';
import AccessWrapper from '../components/AccessWrapper';

export default function OpenReferrals() {
  let { authTokens, user, postPageView, baseUrl } = useContext(AuthContext);

  /* state variables to hold json data from the back-end */
  let [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getReferrals();
    postPageView(baseUrl, user.name, user.role, 'open-referrals');
  }, []);

  let getReferrals = async () => {
    setLoading(true);
    let response = await fetch(
      `${baseUrl}/mtss/referrals/?referrals_only=true`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    let data = await response.json();

    if (response.status === 200) {
      setReferrals(data);
      setLoading(false);
    } else if (response.status === 403) {
      setLoading(false);
      navigate('/unauthorized');
    }
  };

  return (
    <AccessWrapper
      allowedGroups={['mtss_member', 'mtss_supervisor', 'mtss_admin']}
    >
      <div>
        <SidebarLayout
          propComponents={
            <div className='pb-12 sm:pb-16 lg:pb-20'>
              <OpenReferralsTable loading={loading} data={referrals} />
            </div>
          }
          heading={'Referrals'}
          openReferralsCurrent={true}
        />
      </div>
    </AccessWrapper>
  );
}
